import { useObservable } from 'react-use-observable';

import eduzzAccountsService from 'v2/services/eduzzAccount';

export default function useGetUser() {
  const [originalUser] = useObservable(() => eduzzAccountsService.getOriginalUser(), []);

  return originalUser;
}
